import { getRequest, postRequest, putRequest } from "../system/server-calls";
import responseHandler from "../system/server-response-handler";

const getSubscriptionPlans = (roleId) =>
  getRequest(`Subscription/${roleId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const subscribe = (id) =>
  postRequest(`Subscription/subscribe/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getSubscriptions = (roleId) =>
  getRequest(`Subscription/GetUserSubscriptions/${roleId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const cancelSubscription = (roleId) =>
  putRequest(`Subscription/CancelSubscription/${roleId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const changeCard = (roleId) =>
  putRequest(`Subscription/ChangeCard/${roleId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getInvoice = (id, body) =>
  postRequest(`Subscription/Invoice/${id}`, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getUserSubscriptionStatus = (roleId) =>
  getRequest(`subscription/getUserSubscriptionStatus/${roleId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

const getAllSubscriptionPlans = () => {
  return getRequest(`Subscription`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateAllSubscriptionPlans = (data) => {
  return putRequest(`Subscription`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const subscriptionService = {
  subscribe,
  changeCard,
  getSubscriptions,
  cancelSubscription,
  getSubscriptionPlans,
  getInvoice,
  getAllSubscriptionPlans,
  getUserSubscriptionStatus,
  updateAllSubscriptionPlans,
};
